//状态，不允许直接对state操作，只能通过mutations或者actions改变
const state = {
    cityName:'定位中',
    cityCode: null,
    countyType:1,
}


//同步方法
const mutations = {
    getLocation (state,data) {
       console.log(data)
       data.cityName ? state.cityName = data.cityName.split('市')[0] : '';
       data.cityCode ? state.cityCode = data.cityCode : '';
       data.type ? state.countyType = data.type : '';
    }
}

//异步方法
const actions = {
    getLocationAction( {commit},data ){
        commit('getLocation',data)
    }
}
export default{
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/location.js